// src/Pages/UserVideoLessonDetail/Tabs/NotesTab.tsx
import React, { FunctionComponent, useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../Redux/Store/Hooks";
import { ListNoteVideoLesson } from "../../../Redux/Slices/UserVideoLessons/ListNoteVideoLessons";
import { AddNoteVideoLesson } from "../../../Redux/Slices/UserVideoLessons/AddNoteVideoLessons";
import { EditNoteVideoLesson } from "../../../Redux/Slices/UserVideoLessons/EditNoteVideoLessons"; // <-- add this import
import { Note } from "../ILessonsList";
import { DeleteNoteVideoLesson } from "../../../Redux/Slices/UserVideoLessons/DeleteNoteVideoLessons";
import { SvgIcon } from "@mui/material";
import { ReactComponent as WatchLater } from "../../../Assets/Images/Watch_Later.svg";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import CustomSnackbar from "./Snackbar";
import { ReactComponent as NoteEdit } from "../../../Assets/Images/NoteEdit.svg";
import { ReactComponent as NoteDelete } from "../../../Assets/Images/NoteDelete.svg";
interface NotesTabProps {
  currentVideoTime: number;
  videoid: number;
}

const IconBook: React.FC = () => <span className="icon-placeholder">📖</span>;

export const NotesTab: FunctionComponent<NotesTabProps> = ({
  currentVideoTime,
  videoid,
}) => {
  const [newNoteContent, setNewNoteContent] = useState("");
  const [editingNoteId, setEditingNoteId] = useState<number | null>(null);
  const [notes, setNotes] = useState<Note[]>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("Something Wrong!");
  const [title, setTitle] = useState<string>("Something Wrong!");
  const dispatch = useAppDispatch();
  const { data: ListNoteVideo } = useAppSelector(
    (state) => state.ListNoteVideoLessonSliceReducer
  );

  const handleShow = (msg: string, title: string) => {
    setMessage(msg);
    setTitle(title);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const student_id = 282; // TODO: replace with auth

  const formatTime = (timeInSeconds: number): string => {
    const minutes = Math.floor(timeInSeconds / 60)
      .toString()
      .padStart(2, "0");
    const seconds = Math.floor(timeInSeconds % 60)
      .toString()
      .padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  useEffect(() => {
    if (videoid) {
      dispatch(ListNoteVideoLesson({ video_id: videoid }));
    }
  }, [dispatch, videoid]);

  useEffect(() => {
    if (Array.isArray(ListNoteVideo?.data)) {
      setNotes(ListNoteVideo?.data as Note[]);
    }
  }, [ListNoteVideo]);

  const handleAddNote = (): void => {
    if (!newNoteContent.trim()) return;

    const tempNote: Note = {
      id: Date.now(),
      video_id: videoid,
      student_id,
      note: newNoteContent,
      video_time: currentVideoTime,
    };

    setNotes((prev) => [...prev, tempNote]);

    dispatch(
      AddNoteVideoLesson({
        video_id: videoid,
        student_id,
        note: newNoteContent,
        video_time: currentVideoTime,
      })
    );
    console.log("tempNote", currentVideoTime);

    setNewNoteContent("");
    handleShow(`Note saved at ${formatTime(currentVideoTime)}`, "Note added");
  };
  const handleDeleteNote = (id: number): void => {
    const noteToDelete = notes.find((n) => n.id === id);
    if (!noteToDelete) return;
    handleShow("Note has been removed", "Note deleted");
    setNotes((prev) => prev.filter((note) => note.id !== id));
    dispatch(DeleteNoteVideoLesson(noteToDelete));
  };

  const handleStartEdit = (id: number): void => {
    setEditingNoteId(id);
  };

  const handleUpdateNoteContent = (id: number, newContent: string): void => {
    setNotes((prev) =>
      prev.map((note) =>
        note.id === id ? { ...note, note: newContent } : note
      )
    );
  };

  const handleBlurSave = (id: number): void => {
    const updatedNote = notes.find((n) => n.id === id);
    if (updatedNote) {
      dispatch(
        EditNoteVideoLesson({
          id: updatedNote.id,
          video_id: updatedNote.video_id,
          student_id: updatedNote.student_id,
          note: updatedNote.note,
          video_time: updatedNote.video_time,
        })
      );
    }
    setEditingNoteId(null);
    handleShow("Your note has been saved", "Note Updated");
  };

  return (
    <div className="tab-content-container">
      <div className="notes-container">
        {/* Add Note */}
        <div className="note-add-area">
          <h4 className="notes-header">
            <SvgIcon
              component={WatchLater}
              inheritViewBox
              sx={{ fill: "none" }}
            />{" "}
            Notes ({notes.length})
          </h4>

          <textarea
            className="note-textarea"
            placeholder="Add a note at the current time..."
            value={newNoteContent}
            onChange={(e) => setNewNoteContent(e.target.value)}
          ></textarea>

          <div className="note-add-actions">
            <span className="note-time-label">
              Time: {formatTime(currentVideoTime)}
            </span>
            <button
              disabled={newNoteContent?.length <= 0 ? true : false}
              className="add-note-button"
              style={{
                backgroundColor:
                  newNoteContent?.length <= 0 ? "#7faaff" : "#0055ff",
                color: "#ffff",
              }}
              onClick={handleAddNote}
            >
              <SaveOutlinedIcon /> Add Note
            </button>
          </div>
          {notes?.length <= 0 && (
            <p className="check-notes">No notes yet. Add your first note!</p>
          )}
        </div>

        {/* Notes List */}
        <ul className="notes-list">
          {notes.map((note) => (
            <li key={note.id} className="note-item">
              <div className="note-content-wrapper">
                <div className="note-time">
                  <p> {formatTime(note.video_time)}</p>
                  <div className="note-actions">
                    <button
                      // className="icon-button edit-button"
                      onClick={() => handleStartEdit(note.id || 0)}
                    >
                      <SvgIcon
                        component={NoteEdit}
                        inheritViewBox
                        sx={{ fill: "none" }}
                      />
                    </button>
                    <button
                      // className="icon-button delete-button"
                      onClick={() => {
                        handleDeleteNote(note.id || 0);
                      }}
                    >
                      <SvgIcon
                        component={NoteDelete}
                        inheritViewBox
                        sx={{ fill: "none" }}
                      />
                    </button>
                  </div>
                </div>
                {editingNoteId === note.id ? (
                  <>
                    <textarea
                      className="note-content-editable"
                      value={note.note}
                      onChange={(e) =>
                        handleUpdateNoteContent(note.id || 0, e.target.value)
                      }
                      onKeyDown={(e) => {
                        if (e.ctrlKey && e.key === "Enter") {
                          e.preventDefault();
                          handleBlurSave(note.id || 0);
                        }
                      }}
                      autoFocus
                      style={{
                        border: "1px solid #29292aff",
                        padding: "16px",
                        borderRadius: "6px",
                      }}
                    />
                    <p className="note-save-text">Press Ctrl+Enter to save</p>
                  </>
                ) : (
                  <div className="note-content">{note.note}</div>
                )}
                <CustomSnackbar
                  open={open}
                  message={message}
                  onClose={handleClose}
                  title={title}
                  // autoHideDuration={500}
                />
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
